<template>

<aside class="sidebar collapsed">
    <!-- Sidebar Header -->
    <header class="sidebar-header">
        <!-- <a href="#" class="header-logo">
            <img src="logo.png" alt="" />
        </a> -->
        <button class="sidebar-toggler" @click="collapsed">
            <i class="fa-solid fa-bars"></i>
        </button>
    </header>

    <nav class="sidebar-nav">
        <!-- Primary Top Nav -->
        <ul class="nav-list primary-nav">
            <template v-for="item in menu" :key="item.value" >
                <li v-if="'menu' in item && item.menu.length" class="nav-item dropdown-container">
                    <a class="nav-link dropdown-toggle" @click="openSubMenu">
                        <i :class="item.icon"></i>
                        <span class="nav-label">{{ item.text }}</span>
                        <span class="dropdown-icon">
                            <i class="fa-solid fa-chevron-down"></i>
                        </span>
                    </a>
                    <!-- Dropdown Menu -->
                    <ul class="dropdown-menu">
                        <li v-for="link in item.menu" :key="link.value" class="nav-item">
                            <router-link :to="link.url" class="nav-link" :class="('title_class' in link) ? link.title_class : 'dropdown-link'">{{ link.text }}</router-link>
                        </li>
                    </ul>
                </li>
                <li v-else class="nav-item">
                    <router-link :to="item.url" class="nav-link">
                        <i :class="item.icon"></i>
                        <span class="nav-label">{{ item.text }}</span>
                    </router-link>
                    <ul class="dropdown-menu">
                        <li class="nav-item"><a class="nav-link dropdown-title">{{ item.text }}</a></li>
                    </ul>
                </li>
            </template>
        </ul>
    </nav>


</aside>

</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'SideBar',
    data() {
        return {
            menu: [
                {url: '/', icon: 'fa-solid fa-house', text: 'Inicio'},
                {url: '/', icon: 'fa-solid fa-building-columns', text: 'Banca', menu: [
                    {url: '#', icon: '', text: 'Banca',  title_class: 'dropdown-title' },
                    {url: '/cuentas', icon: 'fa-solid fa-wallet', text: 'Mis cuentas'},
                    {url: '/transferencias', icon: 'fa-solid fa-repeat', text: 'Transferencias'},
                    {url: '/movimientos', icon: 'fa-solid fa-list-ul', text: 'Movimientos'},
                    {url: '/tarjetas', icon: 'fa-solid fa-credit-card', text: 'Tarjetas'},
                ]},
                {url: '/', icon: 'fa-solid fa-sliders', text: 'Configuración', menu: [
                    {url: '#', icon: '', text: 'Configuración',  title_class: 'dropdown-title' },
                    {url: '/seguridad', icon: 'fa-solid fa-lock', text: 'Seguridad', },
                    {url: '/perfil', icon: 'fa-solid fa-user-tie', text: 'Perfil', },
                ]},
                // {url: '/pagoServicios', icon: 'fa-solid fa-file-invoice-dollar', text: 'Pago de servicios'},
                // {url: '/alcancia', icon: 'fa-solid fa-piggy-bank', text: 'Alcancía'},
                // {url: '/prestamo/solicitar', icon: 'fa-solid fa-hand-holding-dollar', text: 'Préstamo'},
                // {url: '/preguntas', icon: 'fa-solid fa-circle-question', text: 'Preguntas'},
            ]
        }
    },
    async mounted() {
        // Pago de servicios deshabilitado
        // const isAuth = this.isAuth()
        // if (!isAuth.error && isAuth.ps.estatus) {
        //     this.menu.push({url: '/pagoServicios', icon: 'fa-solid fa-file-invoice-dollar', text: 'Pago de servicios'})
        // }
    },
    methods: {
        ...mapGetters(['user', 'isAuthenticated']),
        isAuth() {
            if (this.isAuthenticated()) {
                return {
                    'error': false,
                    'username': this.user().menu,
                    'ps': this.user().ps
                }
            }
            return {'error': true}
        },
        openSubMenu(event) {
            const dropdownToggle = event.target
            const dropdown = dropdownToggle.closest(".dropdown-container");
            const menu = dropdown.querySelector(".dropdown-menu");
            const isOpen = dropdown.classList.contains("open");

            this.closeAllDropdowns()
            this.toggleDropdown(dropdown, menu, !isOpen); // Toggle current dropdown visibility
            
        },
        closeAllDropdowns() {
            document.querySelectorAll(".dropdown-container.open").forEach((openDropdown) => {
                this.toggleDropdown(openDropdown, openDropdown.querySelector(".dropdown-menu"), false);
            });
        },
        toggleDropdown (dropdown, menu, isOpen) {
            dropdown.classList.toggle("open", isOpen)
            menu.style.height = isOpen ? `${menu.scrollHeight}px` : 0
        },
        collapsed() {
            this.closeAllDropdowns(); // Close all open dropdowns
            document.querySelector(".sidebar").classList.toggle("collapsed"); // Toggle collapsed class on sidebar
        }

    }
};
</script>
<style scoped>
.sidebar {
    position: fixed;
    top: 60px;
    left: 0;
    z-index: 10;
    width: 270px;
    height: 100vh;
    background: var(--second);
    transition: all 0.4s ease;
    border-right: 2px solid var(--alternate);
}

.sidebar.collapsed {
    width: 85px;
}

.sidebar .sidebar-header {
    display: flex;
    position: relative;
    padding: 25px 20px;
    align-items: center;
    justify-content: space-between;
}

.sidebar-header .header-logo img {
    width: 46px;
    height: 46px;
    display: block;
    object-fit: contain;
    border-radius: 50%;
}

.sidebar-header .sidebar-toggler,
.sidebar-menu-button {
    position: absolute;
    right: 20px;
    height: 35px;
    width: 35px;
    color: var(--white);
    border: none;
    cursor: pointer;
    display: flex;
    background: var(--primary);
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    transition: 0.4s ease;
}

/* .sidebar.collapsed .sidebar-header .sidebar-toggler {
    transform: translate(-4px, 65px);
} */

.sidebar-header .sidebar-toggler span,
.sidebar-menu-button span {
    font-size: 1.75rem;
    transition: 0.4s ease;
}

.sidebar.collapsed .sidebar-header .sidebar-toggler span {
    transform: rotate(180deg);
}

.sidebar-nav .nav-list {
    list-style: none;
    display: flex;
    gap: 10px;
    padding: 0 15px;
    flex-direction: column;
    /* transform: translateY(15px); */
    transition: 0.4s ease;
}

.sidebar .sidebar-nav .primary-nav {
    overflow-y: auto;
    scrollbar-width: thin;
    padding-bottom: 20px;
    height: calc(100vh - 227px);
}

.sidebar.collapsed .sidebar-nav .primary-nav {
    overflow: unset;
    /* transform: translateY(65px); */
}

.sidebar-nav .nav-item .nav-link {
    color: var(--white);
    display: flex;
    gap: 12px;
    white-space: nowrap;
    border-radius: 8px;
    padding: .75rem 20px;
    align-items: center;
    text-decoration: none;
    transition: 0.4s ease;
}

.sidebar-nav .nav-item:is(:hover, .open)>.nav-link:not(.dropdown-title) {
    color: var(--second);
    background: linear-gradient(360deg, var(--primary) 0%, var(--primary-soft) 115%);
}

.sidebar .nav-link .nav-label {
    transition: opacity 0.3s ease;
}

.sidebar.collapsed .nav-link :where(.nav-label, .dropdown-icon) {
    opacity: 0;
    pointer-events: none;
}

.sidebar.collapsed .nav-link .dropdown-icon {
    transition: opacity 0.3s 0s ease;
}

.sidebar-nav .secondary-nav {
    position: absolute;
    bottom: 0;
    width: 100%;
}

.sidebar-nav .nav-item {
    position: relative;
}

/* Dropdown Stylings */
.sidebar-nav .dropdown-container .dropdown-icon {
    margin: 0 -4px 0 auto;
    transition: transform 0.4s ease, opacity 0.3s 0.2s ease;
}

.sidebar-nav .dropdown-container.open .dropdown-icon {
    transform: rotate(180deg);
}

.sidebar-nav .dropdown-menu {
    height: 0;
    overflow-y: hidden;
    list-style: none;
    padding-left: 15px;
    transition: height 0.4s ease;
}

.sidebar.collapsed .dropdown-menu {
    position: absolute;
    top: -10px;
    left: 100%;
    opacity: 0;
    height: auto !important;
    padding-right: 10px;
    overflow-y: unset;
    pointer-events: none;
    background: var(--bg-elements);
    color: var(--text-color);
    transition: 0s;
    border: 1px solid #d5d5d5;
}
.dropdown-toggle{
    cursor: pointer;
}
.sidebar.collapsed .dropdown-menu:has(.dropdown-link) {
    padding: 7px 10px 7px 24px;
}

.sidebar.sidebar.collapsed .nav-item:hover>.dropdown-menu {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(12px);
    transition: all 0.4s ease;
}

.sidebar.sidebar.collapsed .nav-item:hover>.dropdown-menu:has(.dropdown-link) {
    transform: translateY(10px);
}

.dropdown-menu .nav-item .nav-link {
    padding: 9px 15px;
}

.sidebar.collapsed .dropdown-menu .nav-link {
    color: var(--text-color);
    padding: 7px 15px;
}

.dropdown-menu .nav-item .nav-link.dropdown-title {
    display: none;
    padding: 9px 15px;
}

.dropdown-menu:has(.dropdown-link) .nav-item .dropdown-title {
    text-align: center;
    font-weight: 800;
    padding: 7px 15px;
}

.sidebar.collapsed .dropdown-menu .nav-item .dropdown-title {
    color: var(--text-color);
    display: block;
}

.sidebar-menu-button {
    display: none;
}

/* Responsive media query code for small screens */
@media (max-width: 768px) {
.sidebar-menu-button {
    position: fixed;
    left: 20px;
    top: 20px;
    height: 40px;
    width: 42px;
    display: flex;
    color: #F1F4FF;
    background: #151A2D;
}

/* .sidebar.collapsed {
    width: 270px;
    left: -270px;
} */

.sidebar.collapsed .sidebar-header .sidebar-toggler {
    transform: none;
}

.sidebar.collapsed .sidebar-nav .primary-nav {
    transform: translateY(15px);
}
}
</style>
